import React from "react";
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import './SomosVolteon.css';

const Envios = () => {
    return (
        <div>
            <Header></Header>
            <div className="volteon-container">
                <div className="volteon-content">
                    <h1>Información de envíos</h1>
                    <p>
                        En Volteon te ofrecemos diferentes opciones mediante las cuales te podemos hacer llegar los
                        productos, dependiendo de la zona del país a la que se desee realizar el envío. A continuación,
                        algunas de nuestras alternativas de envíos:

                    </p>
                    <h2> Instituto Tecnológico de Costa Rica (Sede Central):</h2>
                    <p>
                        Todos los envíos de pedidos dentro de la Sede Central del Instituto Tecnológico de
                        Costa Rica, son gratuitos. Estos se encuentran sujetos a la disponibilidad de personal
                        para realizar la entrega, por lo que también se cuenta con la opción de dejar los
                        pedidos en los puntos de venta para su posterior recolección por parte del cliente. Para
                        más información acerca de nuestros puntos de venta, visitá su respectiva sección.

                    </p>

                    <h2> Cartago Centro, San Sebastián, Alajuelita, Desamparados, Zapote, San
                        Francisco de Dos Ríos, San Pedro y Aserrí:                     </h2>
                    <p>
                        El envío se deberá coordinar con al menos 1 día hábil de antelación y tiene un costo
                        estándar de ₡2500. Este se realizará mediante la plataforma de Uber, por lo que es
                        preciso contactarse por WhatsApp para el respectivo envío de la ubicación y el
                        acuerdo de la hora de envío.
                        De requerir los productos con una mayor urgencia, o a una hora específica, la tarifa
                        se verá sometida a lo que indique la plataforma de Uber en el preciso momento en el
                        que se realice el envío. Siempre los pedidos estarán sujetos a la disponibilidad del
                        personal para enviar los productos.

                    </p>
                    <h2> Resto de la GAM </h2>
                    <p>
                        El envío se deberá coordinar con al menos 1 día hábil de antelación y se realizará
                        mediante la plataforma de Uber, por lo que su costo se verá determinado por lo que
                        indique la aplicación a la hora pactada de enviar el producto. Es recomendable
                        solicitar el envío en un horario de poco tránsito para disminuir las tarifas.
                        Además, es preciso contactarse por WhatsApp para el respectivo envío de la
                        ubicación y el acuerdo de la hora de envío. Siempre los pedidos estarán sujetos a la
                        disponibilidad del personal para enviar los productos.

                    </p>
                    <h2>Resto de Costa Rica</h2>
                    <p>
                        Los envíos a locaciones del país fuera de la GAM se realizan mediante Correos de
                        Costa Rica y tienen un costo estándar de ₡2500, que cubre la tarifa de dicha
                        organización y el respectivo traslado de los productos hacia la sucursal para realizar
                        el despacho.
                        Es preciso enviar los respectivos datos de la dirección por WhatsApp del lugar de
                        entrega o la sucursal más cercana, así como los datos del recipiente, información
                        requerida por Correos de Costa Rica para realizar la entrega adecuadamente.
                    </p>
                </div>
            </div>

            <Footer></Footer>
        </div>

    );
};

export default Envios;